import { IChangeInProgressForStudentModule } from '../Interfaces/IChangeInProgressForStudentModule';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { accessForModuleInProgressInitState } from './InitState';
import SHARING_ACTIONS from '../Actions/ActionTypes';

export const accessForModuleInProgressReducer = (
  state: Array<IChangeInProgressForStudentModule> = accessForModuleInProgressInitState,
  action: IAction<IChangeInProgressForStudentModule>
): Array<IChangeInProgressForStudentModule> => {
  switch (action.type) {
    case SHARING_ACTIONS.SET_ACCESS_FOR_MODULE_START:
      return [...state, action.payload];

    case SHARING_ACTIONS.SET_ACCESS_FOR_MODULE_FINISH:
      return [
        ...state.filter(
          (value) =>
            value.moduleNumber !== action.payload.moduleNumber &&
            value.studentId !== action.payload.studentId
        ),
      ];

    default:
      return state;
  }
};
